import { render } from "./AddAPBeneficiary.vue?vue&type=template&id=fcb99608&scoped=true"
import script from "./AddAPBeneficiary.vue?vue&type=script&lang=js"
export * from "./AddAPBeneficiary.vue?vue&type=script&lang=js"

import "./AddAPBeneficiary.vue?vue&type=style&index=0&id=fcb99608&scoped=true&lang=css"

import exportComponent from "/home/runner/work/APLM/APLM/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fcb99608"]])

export default __exports__